/** Query keys for the currency reference list. */
export const currencyKeys = {
  all: () => ['currency'] as const,
  list: () => [...currencyKeys.all(), 'list'] as const,
} as const;
